function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M95.532 15.579l7.555-.003c.953 0 1.266.936.899 1.557l-3.133 5.425c-.277.481-.57.778-1.347.778h-3.974l-.013 29.449c0 .573-.465 1.037-1.038 1.037h-6.534a1.038 1.038 0 01-1.037-1.038V23.336h-3.2a1.037 1.037 0 01-1.038-1.037v-5.682c0-.573.464-1.038 1.038-1.038h3.2v-1.335c0-7.805 6.29-14.262 14.096-14.22.659.004 1.31.041 1.943.145.86.141 1.341.766 1.341 1.542v4.677c0 .63-.49 1.122-1.182 1.026a6.688 6.688 0 00-7.575 6.591l-.001.002v1.572z",
  fill: "#000"
});

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "bbfc-logo--black_svg__a",
  maskUnits: "userSpaceOnUse",
  x: 42,
  y: 0,
  width: 39,
  height: 55
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M42.721 0h38.101v54.707h-38.1V0z",
  fill: "#fff"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#bbfc-logo--black_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M73.394 35.324c0-6.418-5.204-11.622-11.622-11.622-6.42 0-11.623 5.204-11.623 11.622 0 6.42 5.203 11.623 11.623 11.623 6.418 0 11.622-5.204 11.622-11.623zm7.428 0c0 10.705-8.53 19.383-19.05 19.383a18.73 18.73 0 01-10.429-3.165v1.242c0 .573-.465 1.037-1.037 1.037h-6.548a1.037 1.037 0 01-1.037-1.037V8.602c0-1.032.358-1.934 1.14-2.75l5.49-5.49c.735-.737 1.992-.29 1.992.824v17.92a18.728 18.728 0 0110.43-3.164c10.52 0 19.05 8.678 19.05 19.382z",
  fill: "#000"
}));

var _ref4 = /*#__PURE__*/React.createElement("mask", {
  id: "bbfc-logo--black_svg__b",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 39,
  height: 55
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 0h38.1v54.707H0V0z",
  fill: "#fff"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#bbfc-logo--black_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.672 35.324c0-6.418-5.203-11.622-11.622-11.622-6.418 0-11.622 5.204-11.622 11.622 0 6.42 5.204 11.623 11.622 11.623 6.42 0 11.622-5.204 11.622-11.623zm7.428 0c0 10.705-8.529 19.383-19.05 19.383a18.732 18.732 0 01-10.428-3.165v1.242c0 .573-.464 1.037-1.037 1.037H1.037A1.037 1.037 0 010 52.784V8.602c0-1.032.358-1.934 1.14-2.75L6.63.361c.735-.737 1.992-.29 1.992.824v17.92a18.73 18.73 0 0110.428-3.164c10.521 0 19.05 8.678 19.05 19.382z",
  fill: "#000"
}));

var _ref6 = /*#__PURE__*/React.createElement("mask", {
  id: "bbfc-logo--black_svg__c",
  maskUnits: "userSpaceOnUse",
  x: 103,
  y: 15,
  width: 33,
  height: 40
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M103.481 15.942h32.266v38.764h-32.266V15.942z",
  fill: "#fff"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#bbfc-logo--black_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M135.051 47.643l-4.668-2.695a1.552 1.552 0 00-1.662.07 10.902 10.902 0 01-6.19 1.929c-6.418 0-11.622-5.204-11.622-11.622 0-6.42 5.204-11.623 11.622-11.623 2.289 0 4.415.71 6.19 1.929a1.56 1.56 0 001.662.07l4.668-2.695c.856-.47.909-1.45.231-2.078-3.242-3.004-7.846-4.986-12.751-4.986-10.52 0-19.05 8.678-19.05 19.383 0 10.703 8.53 19.38 19.05 19.38 4.905 0 9.375-1.886 12.751-4.985a1.297 1.297 0 00-.231-2.077z",
  fill: "#000"
}));

function SvgBbfcLogoBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 136 55",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

export default SvgBbfcLogoBlack;